const en = {
  pleaseSelectPart: 'Please select a part',
  pleaseEnterValidQuantity: 'Please enter a valid quantity',
  insufficientStock: 'Insufficient stock! Available: {{available}}, Needed: {{needed}}',
  partAlreadyAdded: 'This part is already added',
  selectPart: 'Select part',
  stock: 'Stock',
  qty: 'Qty',
  notesOptional: 'Notes (optional)',
};

const de = {
  pleaseSelectPart: 'Bitte wählen Sie ein Teil aus',
  pleaseEnterValidQuantity: 'Bitte geben Sie eine gültige Menge ein',
  insufficientStock: 'Unzureichender Bestand! Verfügbar: {{available}}, Benötigt: {{needed}}',
  partAlreadyAdded: 'Dieses Teil wurde bereits hinzugefügt',
  selectPart: 'Teil auswählen',
  stock: 'Bestand',
  qty: 'Menge',
  notesOptional: 'Notizen (optional)',
};

const partSelector = { en, de };
export default partSelector;
